import { Avatar, Card, Divider, Empty, Modal, notification, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { translation } from "../../../i18n/translationConstant";
import LinkedDelinkedAccountResponse, {
  LinkedDelinkedAccountObject,
} from "../../../Models/Response/Account/LinkedDelinkedAccounts";
import {
  delinkAccounts,
  delinkAccountVerification,
  getLinkedAccountsOfUser,
} from "../../../Services/AccountsServices/AccountService";
import { authType } from "../../../Utils/Constants/authType";
import { Routes } from "../../../Utils/Constants/routes";

import EMPTY_STATE from "../../../Assets/empty_state.png";

import "./index.css";
import ConsentStatusApprovalComponent from "../../Consent/Components/StatusApproval";

const Accounts: React.FC = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [linkedAccounts, setLinkedAccounts] = useState(
    new Array<LinkedDelinkedAccountObject>()
  );
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [isAuthTypeOTPModalVisible, setIsAuthTypeOTPModalVisible] =
    useState(false);
  const [isPinModalVisible, setIsPinModalVisible] = useState(false);
  const [radioSelect, setRadioSelect] = useState(0);

  const [selectedAccount, setSelectedAccount] = useState({
    fipHandle: "",
    accountRefNumber: "",
    accountType: "",
    fiType: "",
    linkRefNumber: "",
    logoUrl: "",
    maskedAccNumber: "",
    fipName: "",
    txnId: "",
  });

  useEffect(() => {
    getLinkedAccounts();
  }, []);

  const getLinkedAccounts = () => {
    getLinkedAccountsOfUser()
      .then((res) => res.data)
      .then((res: LinkedDelinkedAccountResponse) => {
        setLinkedAccounts(res);
      });
  };

  const closeModal = () => {
    if (radioSelect === 0) {
      setIsPinModalVisible(false);
    } else setIsOTPModalVisible(false);
  };

  const onDelinkAccount = (otp: string) => {
    if (radioSelect === 0) {
      delinkAccountVerification({
        FipId: selectedAccount.fipHandle,
        txnId: selectedAccount.txnId,
        linkRefNumber: selectedAccount.linkRefNumber,
        authType: authType.PIN,
        authValue: otp,
        otpUniqueID,
      }).then(() => {
        notification.success({
          message: t(translation.lblAccountUnLinkedSuccess),
        });
        push(Routes.account);
        getLinkedAccounts();
        setIsOTPModalVisible(false);
        setIsPinModalVisible(false);
      });
    } else {
      delinkAccountVerification({
        FipId: selectedAccount.fipHandle,
        txnId: selectedAccount.txnId,
        linkRefNumber: selectedAccount.linkRefNumber,
        authType: authType.OTP,
        authValue: otp,
        otpUniqueID,
      }).then(() => {
        notification.success({
          message: t(translation.lblAccountUnLinkedSuccess),
        });
        push(Routes.account);
        getLinkedAccounts();
        setIsPinModalVisible(false);
        setIsOTPModalVisible(false);
      });
    }
  };

  // const delinkAccount = () => {
  // // setIsAuthTypeOTPModalVisible(true);

  //   // Directly call delinkAccounts API to get OTP
  //   setRadioSelect(1);
  //   delinkAccounts({
  //     FipId: selectedAccount.fipHandle,
  //     txnId: selectedAccount.txnId,
  //     linkRefNumber: selectedAccount.linkRefNumber,
  //   })
  //     .then((res) => res.data)
  //     .then((res) => {
  //       setOTPUniqueId(res.otpUniqueID);   // Store OTP unique ID
  //       setIsOTPModalVisible(true);        // Show OTP modal
  //       setIsPinModalVisible(false);       // Hide PIN modal if open
  //       setIsAuthTypeOTPModalVisible(false); // Hide selection modal
  //     });
  // };


const delinkAccount = () => {

  delinkAccounts({
    FipId: selectedAccount.fipHandle,
    txnId: selectedAccount.txnId,
    linkRefNumber: selectedAccount.linkRefNumber,
  })
    .then((res) => res.data)
    .then((res) => {
      // Instead of showing OTP modal, directly call unlink verification
      delinkAccountVerification({
        FipId: selectedAccount.fipHandle,
        txnId: selectedAccount.txnId,
        linkRefNumber: selectedAccount.linkRefNumber,
        authType: authType.NONE,
        authValue: res.otp || "",      
        otpUniqueID: res.otpUniqueID,
      }).then(() => {
        notification.success({
          message: t(translation.lblAccountUnLinkedSuccess),
        });
        push(Routes.account);
        getLinkedAccounts();
      });
    });
};




  const radioSelectEvent = (e: number) => setRadioSelect(e);
  const onSelectionModal = () => {
    setIsAuthTypeOTPModalVisible(false);
    if (radioSelect === 0) {
      setIsPinModalVisible(true);
    } else {
      delinkAccounts({
        FipId: selectedAccount.fipHandle,
        txnId: selectedAccount.txnId,
        linkRefNumber: selectedAccount.linkRefNumber,
      })
        .then((res) => res.data)
        .then((res) => {
          setIsOTPModalVisible(true);
          setOTPUniqueId(res.otpUniqueID);
        });
    }
  };

  return (
    <>
      <ConsentStatusApprovalComponent
        typeOfModal={"Unlink Account"}
        isAuthTypeSelectionModalVisible={isAuthTypeOTPModalVisible}
        onCloseAuthTypeSelectionModal={() =>
          setIsAuthTypeOTPModalVisible(false)
        }
        onAuthTypeModalSubmit={onSelectionModal}
        onAuthTypeRadioSelectionChange={radioSelectEvent}
        selectedAuthType={radioSelect}
        verifyOTPAuthType={onDelinkAccount}
        isAuthTypeOTPModalVisible={isOTPModalVisible}
        onCloseOTPModal={closeModal}
        pinModalVisible={isPinModalVisible}
      />
      <div className="accountsHeader">
        <Typography.Title level={4}>{t("lblLinkedAccounts")}</Typography.Title>
        <button
          className="ant-btn ant-btn-default LinkNewAccountButton"
          onClick={() => push(Routes.linkAccounts)}
        >
          <span style={{ fontWeight: "bolder" }}>{t("lblLinkAccount")}</span>
        </button>
      </div>

      <div className="accountsRoot">
        {linkedAccounts.length ? (
          linkedAccounts.map(
            (account: LinkedDelinkedAccountObject, index: number) => (
              <Card className="linkedAccountCard configWidth48" key={index}>
                <Avatar className="consentAvatar" src={account.logoUrl} />
                <div className="flexGrow1">
                  <div className="column spaceBetween fipView">
                    <Typography.Text className="accountCardFIPText">
                      {account && account.fipName}
                    </Typography.Text>
                    <Typography.Text
                      className="delinkButton"
                      // type="danger"
                      style={{ color: "#00AF6D", fontWeight: "bold" }}
                      // tslint:disable-next-line: jsx-no-lambda
                      onClick={() => {
                        setSelectedAccount(account);
                        delinkAccount();
                      }}
                    >
                      {t("Unlink Account")}
                    </Typography.Text>
                  </div>
                  <div className="fipAccountView">
                    <Typography.Text className="accountCardNumber">
                      {account.maskedAccNumber}
                    </Typography.Text>
                    {/* <Divider type="vertical" /> */}
                  </div>
                    <Typography.Text className="accountCardAccountType">
                      {account.accountType}
                    </Typography.Text>
                    <Divider type="vertical" />
                    <Typography.Text className="accountCardAccountType">
                      {account.fiType}
                    </Typography.Text>
                </div>
              </Card>
            )
          )
        ) : (
          <Empty
            style={{ margin: "10px auto" }}
            image={EMPTY_STATE}
            description={
              <>
                <Typography.Text className={`consentErrorMsg`}>
                  Oops!{"\n "}
                </Typography.Text>
                <br />
                <Typography.Text className="consentErrorSubText">
                  {t("Looks like you don’t have any accounts.")}
                </Typography.Text>
              </>
            }
          />
        )}
      </div>
    </>
  );
};

export default Accounts;
